module.exports = __webpack_public_path__ + "img/oncoKnow logo_transparent-01.b85f576f.png";